import React, { useState, useContext, useEffect } from 'react'

import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

import SidebarContext from '../../../../../context/SidebarContext'

import {
    DarkBackgroundColor,
    ToolboxBlue,
    TrainingPurple,
    InsightsPurple,
} from '../../../../../highcharts/HighchartsStyleHelper'

const GoalBarChart = ({ title, presentations, applications, casesPlaced }) => {
    const DifferenceFromPresentations = (inValue) => {
        const diff = presentations - inValue
        return diff < 0 ? null : diff
    }

    const [internalChart, setInternatChart] = useState(null)

    const { sidebarOpen } = useContext(SidebarContext)

    const reflowChart = (chart, timeout) => {
        setTimeout(() => {
            if (chart && chart.reflow) {
                chart.reflow()
            }
        }, timeout)
    }

    useEffect(() => {
        reflowChart(internalChart, 200)
    }, [sidebarOpen])

    const options = {
        chart: {
            type: 'bar',
            backgroundColor: DarkBackgroundColor,
            height: null,
        },
        title: {
            text: title,
        },
        xAxis: {
            categories: ['Presentations', 'Applications', 'Cases Placed'],
            tickWidth: 0,
            gridLineColor: 'transparent',
            lineColor: 'transparent',
        },
        yAxis: {
            min: 0,
            tickWidth: 0,
            title: null,
            lineColor: 'transparent',
            gridLineColor: 'transparent',
        },
        legend: {
            enabled: false,
        },
        plotOptions: {
            series: {
                stacking: 'normal',
            },
        },
        tooltip: {
            pointFormat: '{point.y}',
        },
        series: [
            {
                color: DarkBackgroundColor,
                borderColor: 'white',
                data: [
                    null,
                    DifferenceFromPresentations(applications),
                    DifferenceFromPresentations(casesPlaced),
                ],
            },
            {
                color: InsightsPurple,
                borderColor: 'white',
                data: [presentations, null, null],
            },
            {
                color: TrainingPurple,
                borderColor: 'white',
                data: [null, applications, null],
            },
            {
                color: ToolboxBlue,
                borderColor: 'white',
                data: [null, null, casesPlaced],
            },
        ],
    }

    return <HighchartsReact highcharts={Highcharts} options={options} callback={setInternatChart} />
}

export default GoalBarChart
